import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { filter } from 'lodash';
import Emoji from 'react-emoji';
import Svg from 'svg-inline-react';
import emojiAnnotationToUnicode from 'emoji-annotation-to-unicode';
import SmileIconSvg from '@src/svgs/chat-smile.svg';
import emojiMap from './emoji_map';
import './styles.scss';

const CATEGORIES = [
  { category: 'people', emoji: ':smiley:' },
  { category: 'nature', emoji: ':seedling:' },
  { category: 'objects', emoji: ':telescope:' },
  { category: 'places', emoji: ':bike:' },
  { category: 'symbols', emoji: ':1234:' },
];

export default class EmojiPicker extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    panelClassName: PropTypes.string,
  };

  state = {
    activeCategory: CATEGORIES[0].category,
    pickerOpen: false,
  };

  pickerRef = null;

  togglePicker = () => {
    this.setState(
      ({ pickerOpen }) => ({ pickerOpen: !pickerOpen }),
      () => {
        if (this.state.pickerOpen) {
          this.attachListener();
        }
      },
    );
  };

  clickedOutside = evt => {
    if (!this.pickerRef.contains(evt.target)) {
      this.closePicker();
    }
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('click', this.clickedOutside);
  }

  attachListener = () => {
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('click', this.clickedOutside);
  };

  closePicker = () => {
    this.setState({ pickerOpen: false });
    document.removeEventListener('click', this.clickedOutside);
  };

  onKeyDown = evt => {
    switch (evt.keyCode) {
      case 27:
        evt.preventDefault();
        evt.stopPropagation();
        this.closePicker();
    }
  };

  onSelect = emoji => {
    const key = emoji.replace(/:/g, '');
    const emojiCode = String.fromCodePoint(parseInt(emojiAnnotationToUnicode[key], 16));

    this.props.onSelect(emojiCode);
  };

  setActiveCategory = activeCategory => {
    this.setState({ activeCategory });
  };

  render() {
    const { className, panelClassName } = this.props;
    const { pickerOpen, activeCategory } = this.state;

    return (
      <div className={classnames('emoji-picker', className)} ref={it => (this.pickerRef = it)}>
        <Svg onClick={this.togglePicker} src={SmileIconSvg} />

        {pickerOpen && (
          <div className={classnames('panel-container', panelClassName)}>
            <div className="emoji-category">
              {CATEGORIES.map(({ emoji, category }) => (
                <span
                  className={classnames('emoji-picker-emoji', category === activeCategory && 'active')}
                  key={category}
                  onClick={() => this.setActiveCategory(category)}
                >
                  {Emoji.emojify(emoji)}
                </span>
              ))}
            </div>

            <div className="emoji-body">
              {filter(emojiMap, { category: activeCategory }).map(({ name }) => (
                <span className="emoji-picker-emoji" key={name} onClick={() => this.onSelect(name)}>
                  {Emoji.emojify(`:${name}:`)}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
